import { Box, Dropdown, Icon, MaterialTextInput, RadioButtonGroup, Spacer } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import React, { useEffect, useState } from 'react'
import { RootStore, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { getFingerPrintData, JIO_PAYMENT_BANK_BIN, parseBioMetricDeviceInfo } from '../../util/utill'
import { AadhaarCardStatusModel } from '../AadhaarLinkStatusModel'
import { AadharNumberEditText } from '../AadharNumberEditText'
import { AepsButton } from '../AepsButton'
import { AepsCheckBox } from '../AepsCheckBox'
import { Container } from '../Container'
import { ProgressDialog } from '../ProgressDialog'
import { ScanUserAuth } from '../ScanUserAuth'
import { VidEditText } from '../VidEditText'

interface TransactionQueryProps {
  onSubmit: any
  isLoading: any
  buttonText?: string
  isDisabled?: boolean
  screenName?: string
  showFingerPrintModel?: boolean
  params: any
  shouldShowLinkAadhaarDialog?: any
  activityType: 'CUSTOMER_CW' | 'CUSTOMER_CD' | 'CUSTOMER_BI' | 'CUSTOMER_FT' | 'CUSTOMER_MS'
  onBankNameChanged?: any
}

export const TransactionQueryComp = ({
  onSubmit,
  isLoading,
  buttonText,
  isDisabled,
  screenName,
  showFingerPrintModel = true,
  params,
  shouldShowLinkAadhaarDialog = false,
  activityType,
  onBankNameChanged,
}: TransactionQueryProps) => {
  const { getBankList, getConsent, setBioMetricDeviceInfo, sendEventAsync } = useStores((root) => ({
    getBankList: root.banks.getBankList,
    getConsent: root.consents.getConsent,
    setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
    sendEventAsync: root.agent.session.sendEventAsync,
  }))
  const [bankName, setBankName] = useState('')
  const [aadhaarCard, setAadhaarCard] = useState({
    num: params?.aadhaarNo ?? '',
    isValid: params?.aadhaarNo ? true : false,
  })

  const PLACEHOLDERS = STATIC_DATA[screenName ?? ''] ?? STATIC_DATA.DEFAULT

  const [vid, setVid] = useState(params?.vid ?? '')
  const [mobileNo, setMobileNo] = useState(params?.mobileNo ?? '')
  const [mobileNoError, setMobileNoError] = useState('')
  const [checked, setChecked] = useState(false)
  const [beneficieryBankName, setBeneficieryBankName] = useState('')
  const [beneficieryAadhaarCard, setBeneficieryAadhaarCard] = useState({ num: '', isValid: false })
  const [confirmBeneficieryAadhaarCard, setConfirmBeneficieryAadhaarCard] = useState({ num: '', isValid: false })

  const [aadhaarCardStatusInfoModel, setAadhaarCardInfoModel] = useState({ show: false, type: 'NOT_LINKED' })
  const [payersRadioOption, setPayersRadioOption] = useState(
    params?.vid ? PLACEHOLDERS.payer_radio_button_label[1] : PLACEHOLDERS.payer_radio_button_label[0],
  )

  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = useState(false)
  const banks = getBankList(screenName ?? '', activityType)
  const [fingerPrintError, setFingerPrintError] = useState({ code: '', error: '', title: '' })
  //const [authMode, setAuthMode] = useState<'FACE' | 'FINGER_PRINT'>('FINGER_PRINT')
  const authModeRef = React.useRef(null)
  const navigation = useNavigation<any>()

  useEffect(() => {
    if (screenName === Screens.FUND_TRANSFER) {
      const bankName = banks?.filter((bank) => bank.bankBin === JIO_PAYMENT_BANK_BIN)?.[0]?.text
      setBankName(bankName)
    }
    const selectedBank = banks?.find((bank) => bank.text === params?.bankName)
    if (screenName !== Screens.FUND_TRANSFER && selectedBank) {
      onBankNameChanged && onBankNameChanged(selectedBank.bankBin)
      setBankName(params?.bankName)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const validateMobileNum = () => {
    if (
      mobileNo.length !== 10 ||
      !(
        mobileNo.indexOf('6') === 0 ||
        mobileNo.indexOf('7') === 0 ||
        mobileNo.indexOf('8') === 0 ||
        mobileNo.indexOf('9') === 0
      )
    ) {
      setMobileNoError('Enter valid Mobile no.')
    } else {
      setMobileNoError('')
    }
  }

  useEffect(() => {
    if (shouldShowLinkAadhaarDialog) {
      !aadhaarCardStatusInfoModel.show && setAadhaarCardInfoModel({ show: true, type: 'NOT_LINKED' })
    }
  }, [aadhaarCardStatusInfoModel.show, shouldShowLinkAadhaarDialog])

  const onAadhaarCardTextChange = (text: any, isValidAadhaar: boolean) =>
    setAadhaarCard({ num: text, isValid: isValidAadhaar })

  const onMobileNoChanged = (text: any) => {
    text = text.replace(/[^0-9]/g, '')
    setMobileNo(text)
  }

  const getTrimmedAadhaarCard = (aadhaar: string) => aadhaar.replace(/ /g, '')

  const isBanificieryCardInvalid = () => {
    const beneficieryAadhaar = getTrimmedAadhaarCard(beneficieryAadhaarCard.num)
    const confirmBeneficieryAadhaar = getTrimmedAadhaarCard(confirmBeneficieryAadhaarCard.num)
    return (
      beneficieryAadhaar.length !== 12 ||
      !beneficieryAadhaarCard.isValid ||
      confirmBeneficieryAadhaar.length !== 12 ||
      !confirmBeneficieryAadhaarCard.isValid ||
      beneficieryAadhaar !== confirmBeneficieryAadhaar
    )
  }

  const isInvalidMobileNo = () => {
    return !(
      mobileNo.indexOf('6') === 0 ||
      mobileNo.indexOf('7') === 0 ||
      mobileNo.indexOf('8') === 0 ||
      mobileNo.indexOf('9') === 0
    )
  }

  const shouldDisableButton = () => {
    if (screenName === Screens.FUND_TRANSFER) {
      return (
        isDisabled ||
        !bankName ||
        (payersRadioOption === PLACEHOLDERS.payer_radio_button_label[0] && !aadhaarCard.isValid) ||
        (payersRadioOption === PLACEHOLDERS.payer_radio_button_label[1] && vid.length !== 16) ||
        mobileNo.length !== 10 ||
        isInvalidMobileNo() ||
        !beneficieryBankName ||
        isBanificieryCardInvalid()
      )
    }

    return (
      isDisabled ||
      !bankName ||
      (payersRadioOption === PLACEHOLDERS.payer_radio_button_label[0] && !aadhaarCard.isValid) ||
      (payersRadioOption === PLACEHOLDERS.payer_radio_button_label[1] && vid.length !== 16) ||
      mobileNo.length !== 10 ||
      (screenName !== Screens.CASH_W_OR_D_Screen && !checked)
    )
  }

  const onScanSuccess = (sucess: any) => {
    getFingerPrintData(sucess, getConsent(activityType as any), authModeRef.current).then((fingerprintData: any) => {
      const aadhaarNo = aadhaarCard.num.replace(/ /g, '').trim()
      const beneficieryAadhaar = beneficieryAadhaarCard.num.replace(/ /g, '').trim()
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })

      onSubmit({
        bankName,
        aadhaarNo,
        vid,
        mobileNo,
        beneficieryBankName,
        beneficieryAadhaar,
        fingerprintData,
        authMode: authModeRef?.current,
      })
      setShouldShowFingerPrintModel(false)
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }

  const onSubmitPress = (authenticationMode: 'FACE' | 'FINGER_PRINT') => {
    authModeRef.current = authenticationMode
    if (params) {
      params.aadhaarNo = aadhaarCard?.num?.replace(/ /g, '').trim()
      params.vid = vid
    }
    setFingerPrintError({ code: '', error: '', title: '' })
    if (showFingerPrintModel && window?.AepsWebViewInterface) {
      setShouldShowFingerPrintModel(true)
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode: authenticationMode })
    } else {
      const aadhaarNo = aadhaarCard.num.replace(/ /g, '').trim()
      const beneficieryAadhaar = beneficieryAadhaarCard.num.replace(/ /g, '').trim()
      onSubmit({
        bankName,
        aadhaarNo,
        vid,
        mobileNo,
        beneficieryBankName,
        beneficieryAadhaar,
        authMode: authenticationMode,
      })
    }
  }

  const goBackToHomeScreen = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    navigation.canGoBack() && navigation.goBack()
  }

  const onAadhaarCardLinked = () => {
    setAadhaarCardInfoModel({ show: true, type: 'LINKED' })
  }

  const onPrimaryButtonClick = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    if (aadhaarCardStatusInfoModel.type == 'NOT_LINKED') {
      const aadhaarNo = aadhaarCard.num.replace(/ /g, '').trim()
      navigation.navigate(Screens.ENTER_CUSTOMER_MOBILE as never, { aadhaarNo, mobileNo, onAadhaarCardLinked } as never)
    } else {
      onSubmitPress(authModeRef?.current)
    }
  }
  const isBothCardSame = () => {
    return (
      beneficieryAadhaarCard.isValid &&
      confirmBeneficieryAadhaarCard.isValid &&
      beneficieryAadhaarCard.num === confirmBeneficieryAadhaarCard.num
    )
  }

  const getErrorForDiffAddharCard = () => {
    return (
      beneficieryAadhaarCard.isValid &&
      confirmBeneficieryAadhaarCard.isValid &&
      beneficieryAadhaarCard.num !== confirmBeneficieryAadhaarCard.num &&
      'Payee Aadhaar Number doesn’t match.'
    )
  }

  return (
    <Container
      showFooter={true}
      showBrandLogo={true}
      emptyMessage={screenName === Screens.FUND_TRANSFER && !bankName && ('Error while fetching bank list' as any)}>
      <Box f={1} overflow={'scroll'}>
        <Dropdown
          data={banks}
          label={PLACEHOLDERS.payers_bank_placeholder}
          type="Material"
          value={bankName}
          animatedColorValue="#DF9F39"
          tintColor="PRIMARY"
          placeholderTextColor="#DF9F39"
          dropdownTextColor="PRIMARY_STORNG"
          dropdownHeaderColor="PRIMARY"
          showDownArrow={screenName === Screens.FUND_TRANSFER ? false : true}
          nonEditableTextColor="GRAY_75"
          editable={screenName === Screens.FUND_TRANSFER ? false : true}
          onChange={(text) => {
            if (onBankNameChanged) {
              const selectedBank = banks?.find((bank) => bank.text === text)
              onBankNameChanged(selectedBank?.bankBin)
            }
            setBankName(text)
          }}
        />
        <RadioButtonGroup
          data={PLACEHOLDERS.payer_radio_button_label}
          direction="horizontal"
          value={params?.vid ? PLACEHOLDERS.payer_radio_button_label[1] : PLACEHOLDERS.payer_radio_button_label[0]}
          onChange={(text: string) => {
            if (text !== payersRadioOption) {
              setAadhaarCard({
                num: '',
                isValid: false,
              })
              setVid('')
              if (params) {
                params.aadhaarNo = ''
                params.vid = ''
              }
              setPayersRadioOption(text)
            }
          }}
          size={16}
          textSize={12}
          textColor="PRIMARY_STORNG"
          color="PRIMARY_STORNG"
        />

        {payersRadioOption === PLACEHOLDERS.payer_radio_button_label[0] && (
          <AadharNumberEditText
            initialVal={params?.aadhaarNo ?? ''}
            onTextChanged={onAadhaarCardTextChange}
            label={PLACEHOLDERS.payers_aadhaar_placeholder}
            type="MATERIAL"
          />
        )}

        {payersRadioOption === PLACEHOLDERS.payer_radio_button_label[1] && (
          <VidEditText
            initialVal={params?.vid ?? ''}
            onTextChanged={(vid: string) => setVid(vid)}
            label={PLACEHOLDERS.payers_vid_placeholder}
          />
        )}

        <MaterialTextInput
          placeholder={PLACEHOLDERS.payers_phone}
          testID="mobile-input"
          value={mobileNo}
          onChange={onMobileNoChanged}
          maxLength={10}
          onBlur={validateMobileNum}
          onFocus={() => {
            setMobileNoError('')
          }}
          animatedColorValue="#DF9F39"
          tintColor="PRIMARY"
          keyboardType="numeric"
          error={mobileNoError}
        />

        {screenName === Screens.FUND_TRANSFER && (
          <>
            <Dropdown
              data={banks}
              label={PLACEHOLDERS.beneficiery_bank_placeholder}
              type="Material"
              value={beneficieryBankName}
              onChange={(text) => setBeneficieryBankName(text)}
              animatedColorValue="#DF9F39"
              tintColor="PRIMARY"
              placeholderTextColor="#DF9F39"
            />
            <AadharNumberEditText
              onTextChanged={(text: any, isValidAadhaar: boolean) =>
                setBeneficieryAadhaarCard({ num: text, isValid: isValidAadhaar })
              }
              label={PLACEHOLDERS.beneficiery_aadhaar_placeholder}
              type="MATERIAL"
            />
            <AadharNumberEditText
              onTextChanged={(text: any, isValidAadhaar: boolean) =>
                setConfirmBeneficieryAadhaarCard({ num: text, isValid: isValidAadhaar })
              }
              error={getErrorForDiffAddharCard()}
              label={PLACEHOLDERS.confirm_beneficiery_aadhaar_placeholder}
              type="MATERIAL"
              rightSideComponent={
                isBothCardSame() && (
                  <>
                    <Icon id={'ROUND_TICK_FILLED'} color="AVAILABLE_GREEN" size={16} />
                    <Spacer direction="horizontal" size={16} />
                  </>
                )
              }
            />
          </>
        )}
        {!(screenName === Screens.FUND_TRANSFER || screenName === Screens.CASH_W_OR_D_Screen) && (
          <>
            <Spacer size={28} />
            <AepsCheckBox
              text={getConsent(activityType as any)}
              checked={checked}
              onChange={(ischecked: boolean) => setChecked(ischecked)}
            />
            <Spacer size={20} />
          </>
        )}
      </Box>
      {showFingerPrintModel && (
        <ScanUserAuth onPress={onSubmitPress} isLoading={isLoading} disabled={shouldDisableButton()} />
      )}
      {!showFingerPrintModel && (
        <AepsButton onPress={onSubmitPress} title={buttonText} isLoading={isLoading} disabled={shouldDisableButton()} />
      )}
      <ProgressDialog
        error={fingerPrintError}
        onRetry={onSubmitPress}
        show={shouldShowFingerPrintModel || isLoading}
        type={
          fingerPrintError.code
            ? 'error'
            : isLoading
            ? 'loader'
            : authModeRef.current === 'FACE'
            ? 'face'
            : 'fingerprint'
        }
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
      <AadhaarCardStatusModel
        status={aadhaarCardStatusInfoModel.type as any}
        show={aadhaarCardStatusInfoModel.show}
        onPrimaryButtonPress={onPrimaryButtonClick}
        onSecondaryButtonPress={goBackToHomeScreen}
      />
    </Container>
  )
}

const STATIC_DATA = {
  [Screens.FUND_TRANSFER]: {
    payers_bank_placeholder: 'Payer’s Bank',
    payers_aadhaar_placeholder: 'Payer’s Aadhar Number',
    payers_vid_placeholder: 'Payer’s VID Number',
    payers_phone: 'Payer’s Phone Number',
    beneficiery_bank_placeholder: 'Payee Bank',
    beneficiery_aadhaar_placeholder: 'Payee Aadhar Number',
    confirm_beneficiery_aadhaar_placeholder: 'Confirm Payee Aadhar Number',
    payer_radio_button_label: ['Aadhar Number', 'VID'],
    beneficiery_vid_placeholder: 'Payee Vid Number',
    confirm_beneficiery_vid_placeholder: 'Confirm Payee Vid Number',
  },
  DEFAULT: {
    payers_bank_placeholder: 'Customer’s Bank Name',
    payers_aadhaar_placeholder: 'Customer’s Aadhar Number',
    payers_vid_placeholder: 'Customer’s  VID Number',
    payers_phone: 'Customer’s Phone Number',
    beneficiery_bank_placeholder: 'Payee Bank',
    beneficiery_aadhaar_placeholder: 'Payee Aadhar Number',
    confirm_beneficiery_aadhaar_placeholder: 'Confirm Payee Aadhar Number',
    payer_radio_button_label: ['Aadhar Number', 'VID'],
    beneficiery_vid_placeholder: 'Payee Vid Number',
    confirm_beneficiery_vid_placeholder: 'Confirm Payee Vid Number',
  },
}
